export type Mappings = {
  idToLabel: Record<string, string>;
  labelToId: Record<string, any>;
};

export const mapValueByMappings = (
  value: string,
  columnId: string,
  statusMappings?: Mappings,
  categoryMappings?: Mappings,
): string => {
  if (columnId === "status" && statusMappings?.idToLabel) {
    const mappedLabel = statusMappings.idToLabel[value];
    return mappedLabel || value;
  } else if (columnId === "category" && categoryMappings?.idToLabel) {
    const mappedLabel = categoryMappings.idToLabel[value];
    return mappedLabel || value;
  }
  return value;
};

export const convertLabelsToIds = (
  labels: string[],
  columnId: string,
  statusMappings?: Mappings,
  categoryMappings?: Mappings,
): string[] => {
  if (!labels.length) return [];

  const labelToIdMap =
    columnId === "status"
      ? statusMappings?.labelToId
      : columnId === "category"
      ? categoryMappings?.labelToId
      : undefined;

  if (!labelToIdMap) return labels;

  return labels.map((label) => {
    const id = labelToIdMap[label];
    return id !== undefined ? String(id) : label;
  });
};

export const convertFieldKeyFilterValues = (
  fieldKey: string,
  values: string[],
  statusMappings?: Mappings,
  categoryMappings?: Mappings,
): string[] => {
  if (!values.length) return values;

  let labelToIdMap: Record<string, any> | undefined;
  if (fieldKey.includes("chat_thread:status") && statusMappings?.labelToId) {
    labelToIdMap = statusMappings.labelToId;
  } else if (
    fieldKey.includes("chat_thread:category") &&
    categoryMappings?.labelToId
  ) {
    labelToIdMap = categoryMappings.labelToId;
  }

  if (!labelToIdMap) return values;

  return values.map((label) => {
    const id = (labelToIdMap as Record<string, any>)[label];
    return id !== undefined ? String(id) : label;
  });
};

type OptionId = string | number;

const toNumberArray = (ids: OptionId[]): number[] => {
  return ids
    .map((id) => (typeof id === "string" ? parseInt(id, 10) : id))
    .filter((id): id is number => !isNaN(id) && typeof id === "number");
};

export const convertFieldKeyFilterValuesToNumbers = (
  fieldKey: string,
  values: string[],
  statusMappings?: Mappings,
  categoryMappings?: Mappings,
): number[] => {
  if (!values.length) return [];

  let labelToIdMap: Record<string, any> | undefined;
  if (fieldKey.includes("chat_thread:status") && statusMappings?.labelToId) {
    labelToIdMap = statusMappings.labelToId;
  } else if (
    fieldKey.includes("chat_thread:category") &&
    categoryMappings?.labelToId
  ) {
    labelToIdMap = categoryMappings.labelToId;
  }

  if (!labelToIdMap) return [];

  const ids = values
    .map((label) => (labelToIdMap as Record<string, any>)[label])
    .filter((id: OptionId | undefined): id is OptionId => id !== undefined);

  return toNumberArray(ids);
};
